import { BaseService } from "../../Base/BaseService";
import { IPublicMasterService } from "../PublicMasterProfile/PublicMasterProfileService";

export interface ICreateBookingRequestRequest {
  serviceId: number;
  clientName: string;
  contact: string;
  preferredTime: string;
  comment: string;
}

export interface ICreateBookingRequestResponse {
  id: number;
  masterId: number;
  serviceId: number;
  clientUserId: number | null;
  clientName: string;
  contact: string;
  preferredTime: string;
  comment: string;
  status: string;
  createdAt: string;
}

export class CreateBookingRequestService extends BaseService {
  private static masterServicesRequests = new Map<number, Promise<IPublicMasterService[]>>();

  public static async GetMasterServices(masterId: number): Promise<IPublicMasterService[]> {
    const existingRequest = this.masterServicesRequests.get(masterId);

    if (existingRequest) {
      return existingRequest;
    }

    const request = this.get<IPublicMasterService[]>(this.BaseApiUrl + `/masters/${masterId}/services`).finally(() => {
      this.masterServicesRequests.delete(masterId);
    });

    this.masterServicesRequests.set(masterId, request);

    return request;
  }

  public static async Create(masterId: number, request: ICreateBookingRequestRequest): Promise<ICreateBookingRequestResponse> {
    return this.post<ICreateBookingRequestResponse>(this.BaseApiUrl + `/masters/${masterId}/booking-requests`, request);
  }
}
